<div id="message-block-container_id" class="message-block-container">
  <div class='new-content-red-box' *ngIf="new">
    {{content.text.new}}
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>